/**
 * 表单校验规范，如果符合的请直接使用。如果没有请联系达尔文前端团队增加。
 */
import supportedRegExps from './rexp'
export const validFn = vue => {
    return {
        //isd登录名
        mustInput: (msg = '', trigger) => {
            return [{ required: true, message: vue.$t('mustInput', [vue.$t(msg)]),trigger }]
        },
        //isd登录名
        isdLoginName: (msg = 'isd.loginName', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.isdName,
                    message: vue.$t('validation.regExp.isdLoginName')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //登录密码
        isdPsw: (msg = 'isd.psw', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.isdPsw,
                    message: vue.$t('validation.regExp.isdPsw')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //ip地址
        ip: (msg = 'device.Ipaddress', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.ip,
                    message: vue.$t('validation.regExp', [vue.$t(msg)])
                },
                {
                    required: isRequired,
                    message: vue.$t('pleaseInputIp', [vue.$t(msg)])
                }
            ]
        },
        //'必须为非负整数'
        pureNum: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.pureNum,
                    message: vue.$t('validation.regExp.pureNum')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //必须为正整数
        positiveInt: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.positiveInt,
                    message: vue.$t('validation.regExp.positiveInt')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //必须为1-8正整数
        positiveInt1_8: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.positiveInt1_8,
                    message: vue.$t('validation.regExp.positiveInt')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //车牌号
        carNum: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.carNum,
                    message: vue.$t('regExpCarNum')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //车牌号
        carNum2: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.carNum2,
                    message: vue.$t('regExpCarNum2')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //'仅允许<b>-_.;()（）</b>或字母数字'
        fieldPass: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.fieldPass,
                    message: vue.$t('validation.regExp.fieldPass')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //'仅允许输入文字、字母、数字'
        userLoginName: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.userLoginName,
                    message: vue.$t('validation.regExp.userLoginName')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //'仅允许输入文字、字母、数字'
        treeName: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.treeName,
                    message: vue.$t('validation.regExp.treeName')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        // n+m正则
        numAndNum: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.numAndNum,
                    message: vue.$t('validation.regExp.numAndNum')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //'仅允许<b>文字字母数字 -_.;#（）[] 半角加号</b>和<b>全角加号</b>以及<b>字符中间有空格</b>'
        commonCharacter: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.commonCharacter,
                    message: vue.$t('validation.regExp.commonCharacter')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //'仅允许<b>文字字母数字</b>'
        nationCharacter: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.nationCharacter,
                    message: vue.$t('validation.regExp.nationCharacter')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        // 编码只能输入大小写字母,数字,_,-
        codeCharacter: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.codeCharacter,
                    message: vue.$t('validation.regExp.codeCharacter')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        // 编码只能输入大小写字母,数字,_,-或邮箱
        codeCharacterOrEmail: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.codeCharacterOrEmail,
                    message: vue.$t('validation.regExp.codeCharacterOrEmail')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /**ftp地址*/
        ftpPath: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.ftpPath,
                    message: vue.$t('validation.regExpFtp')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /**mac地址*/
        mac: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.mac,
                    message: vue.$t('validation.regExpMac')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /***手机号码**/
        phone: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.phone,
                    message: vue.$t('validation.regExpPhone')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /***座机号码**/
        tell: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.tell,
                    message: vue.$t('validation.regExpTell')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        // 描述\备注专用,在CHAR的基础上增加可以开头空格,回车换行符\uff0c\u3002为中文的
        memoCharacterEnter: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.memoCharacterEnter,
                    message: vue.$t('validation.regExp.memoCharacterEnter')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        // 仅允许字母数字_字符
        sn: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.sn,
                    message: vue.$t('validation.sn')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },

        //'仅允许文字字母数字-_.;#(),\/\\（）[]<br/>半角加号和、全角加号以及允许字符中间有空格',
        hikdomain: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.hikdomain,
                    message: vue.$t('validation.regExp.hikdomain')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },

        // 仅允许字母或数字
        numWord: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.numWord,
                    message: vue.$t('validation.regExp.numWord')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },

        // 密码必须同时包含数字和字母
        backupPass: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.backupPass,
                    message: vue.$t('validation.regExp.backupPass')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },

        // 仅允许文字、字母、数字和字符中间空格
        fewCharacter: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.fewCharacter,
                    message: vue.$t('validation.regExp.fewCharacter')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },

        idCard: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.idCard,
                    message: vue.$t('validation.regExp.idCard')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },

        /**校验邮箱是否合法*/
        email: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.email,
                    message: vue.$t('emailError')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        gpsX: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.gpsX,
                    message: vue.$t('validation.gpsX')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        gpsY: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.gpsY,
                    message: vue.$t('validation.gpsY')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /**端口*/
        port: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.port,
                    message: vue.$t('validation.port')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /**设备名称 -中文字母数字（）*/
        deviceName: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.deviceName,
                    message: vue.$t('validation.deviceName')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /**数字编码 -数字*/
        intercomDevIndex2: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.intercomDevIndex2,
                    message: vue.$t('validation.intercomDevIndex')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /**数字编码 -数字*/
        intercomDevIndex3: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.intercomDevIndex3,
                    message: vue.$t('validation.intercomDevIndex')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /**数字编码 -数字\-*/
        intercomDevIndex6: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.intercomDevIndex6,
                    message: vue.$t('validation.intercomDevIndex')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /**密码校验**/
        pswExp: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.pswExp,
                    message: vue.$t('validation.intercomDevIndex')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /**设备编号**/
        int10: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.int10,
                    message: vue.$t('validation.int10')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        /**0-255之间的整数**/
        numCodeExp: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.numCodeExp,
                    message: vue.$t('validation.numCodeExpTip')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        // 仅允许文字、字母、数字和下划线
        name: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.name,
                    message: vue.$t('validation.regExp.name')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },
        //
        usedLayersRules: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.usedLayers,
                    message: vue.$t('validation.regExp.usedLayers')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        },

        // 只能有两位小数点，不超过999999
        checkMoney: (msg = '', isRequired = true) => {
            return [
                {
                    type: 'pattern',
                    pattern: supportedRegExps.decmal3,
                    message: vue.$t('validation.regExp.decmal3')
                },
                {
                    required: isRequired,
                    message: vue.$t('mustInput', [vue.$t(msg)])
                }
            ]
        }
    }
}
